import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const SET_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;

type SetUserPreferenceResult = {
	data: {
		setMyPreference: {
			success: boolean;
		};
	};
	errors?: Array<unknown>;
};

export const setUserPreference = async (key: string, value: string): Promise<void> => {
	try {
		const result: SetUserPreferenceResult = await performPostRequest('/rest/gira/1/', {
			body: JSON.stringify({
				query: SET_USER_PREFERENCE_MUTATION,
				variables: {
					input: { key, value },
				},
			}),
		});

		if (result.data.setMyPreference.success !== true) {
			throw new Error(`Error setting user preference: ${key}`, {
				cause: result.errors?.[0],
			});
		}
	} catch (error) {
		fireErrorAnalytics({
			error: error instanceof Error ? error : undefined,
			meta: {
				id: 'setUserPreference',
				packageName: 'jiraAdminPagesWorkflowsUserPreferences',
				teamName: 'Helix',
			},
		});

		throw error;
	}
};
